import { useConsent } from '@micromag/core/contexts';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';

export const ModalContext = React.createContext({
    container: null,
});

export const useModalContext = () => useContext(ModalContext) || {};

export const useModal = () => {
    const { modal, setModal, unsetModal } = useModalContext() || {};
    return { modal, setModal, unsetModal } || {};
};

const propTypes = {
    children: PropTypes.node.isRequired,
    modal: PropTypes.shape({}),
};

const defaultProps = {
    modal: null,
};

export const ModalProvider = ({ children, modal: initialModal }) => {
    const [modal, setModalState] = useState(initialModal);
    const { consented = null } = useConsent();

    useEffect(() => {
        if (!consented) {
            setModalState('consent');
        }
    }, [consented]);

    const setModal = useCallback(
        (val) => {
            setModalState(val);
        },
        [setModalState],
    );

    const unsetModal = useCallback(() => {
        setModalState(null);
    }, [setModalState]);

    const value = useMemo(
        () => ({
            modal,
            setModal,
            unsetModal,
        }),
        [modal, setModalState, setModal, unsetModal],
    );
    return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};

ModalProvider.propTypes = propTypes;
ModalProvider.defaultProps = defaultProps;
